import { render, staticRenderFns } from "./a-table.vue?vue&type=template&id=6d135fae"
import script from "./a-table.vue?vue&type=script&lang=js"
export * from "./a-table.vue?vue&type=script&lang=js"
import style0 from "./a-table.vue?vue&type=style&index=0&id=6d135fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports